import { render, staticRenderFns } from "./orderlyList.vue?vue&type=template&id=6ebde02a&scoped=true&"
import script from "./orderlyList.vue?vue&type=script&lang=js&"
export * from "./orderlyList.vue?vue&type=script&lang=js&"
import style0 from "./orderlyList.vue?vue&type=style&index=0&id=6ebde02a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebde02a",
  null
  
)

export default component.exports